/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_NotesInputs */

const vi_warehouse_defects_notes = /** @type {(inputs: Warehouse_Defects_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số phiếu`)
};

/**

* @param {Warehouse_Defects_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_notes = /** @type {((inputs?: Warehouse_Defects_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_notes(inputs)
});